import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorksDocuments: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENTS,
	},
	getDoneWorksDocumentPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_PREVIEW,
	},
	getDoneWorksDocumentPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_POPUP,
	},
	createDoneWorksDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].CREATE_DONE_WORKS_DOCUMENT,
	},
	getDoneWorksDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT,
	},
	patchDoneWorksDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PATCH_DONE_WORKS_DOCUMENT,
	},
	putDoneWorksDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PUT_DONE_WORKS_DOCUMENT,
	},
	deleteDoneWorksDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].DELETE_DONE_WORKS_DOCUMENT,
	},
}